"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.footer = void 0;
const basic_1 = require("../basic");
const font_faces_1 = require("./font-faces");
exports.footer = (0, basic_1.applyBase)({
    heading: Object.assign(Object.assign({}, font_faces_1.FONT_SIZE.S), { textAlign: [null, 'start'] }),
});
//# sourceMappingURL=footer.js.map